import React from "react";

export default function MobileDrawer({ open, onClose, children }) {
  return (
    <>
      <div
        className={`mobile-drawer-backdrop ${open ? "show" : ""}`}
        onClick={onClose}
      />
      <div className={`mobile-drawer ${open ? "open" : ""}`}>
        <div className="mobile-drawer-header">
          <h3>Navigation</h3>
          <button
            type="button"
            className="btn btn-ghost"
            onClick={onClose}
          >
            Close
          </button>
        </div>

        {children}
      </div>
    </>
  );
}